import { render, staticRenderFns } from "./CollapseNotificationBtn.vue?vue&type=template&id=993a0f2c&"
import script from "./CollapseNotificationBtn.vue?vue&type=script&lang=js&"
export * from "./CollapseNotificationBtn.vue?vue&type=script&lang=js&"
import style0 from "./CollapseNotificationBtn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports